import { BorderRadius, Color } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Themable } from '../../types/themable'

interface ProcessingOverlayWrapperProps extends Themable {
  bgColor?: Color
  borderRadius?: BorderRadius
  isSticky?: boolean
}

export const ProcessingOverlayWrapper = styled.div<ProcessingOverlayWrapperProps>`
  border-radius: ${({ borderRadius }) => borderRadius ?? 'unset'};
  z-index: 1;

  ${({ isSticky, bgColor, theme }) =>
    isSticky
      ? css`
          width: 100%;
          height: 0;
          /* top: 50% clamps this to mid-scrollport; height: 0 keeps the box from
             filling the (now working) fullHeight chain so the spinner can sit on that point */
          position: sticky;
          top: 50%;
          background-color: transparent;
          overflow: visible;
          pointer-events: none;
        `
      : css`
          opacity: 0.6;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: ${bgColor || theme.ds.colors.base.background};
        `}
`

interface AnimationWrapperProps {
  isSticky?: boolean
}

export const AnimationWrapper = styled.div<AnimationWrapperProps>`
  position: absolute;
  top: ${({ isSticky }) => (isSticky ? '0' : '50%')};
  left: 50%;
  transform: translate(-50%, -50%);
`
